import Layout from '../../internal/Layout.vue'
import ChecklistsPage from './checklists.vue'
import ManageChecklistTemplate from './components/checklistTemplate/ManageTemplate.vue'
import ManageChecklistServiceOrder from './components/ChecklistServiceOrder/ManageChecklistServiceOrder.vue'

const ChecklistsRoutes = {
  component: Layout,
  children: [
    {
      name: 'checklist',
      path: '/',
      component: ChecklistsPage,
      meta: {
        module: 'checklist',
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresSupervisor: true,
        requiresOperator: true,
        requiresCoordOp: true,
        requiresCoordSector: true,
        requiresLaboratory: true,
      },
    },
    {
      name: 'newTemplate',
      path: '/newTemplate',
      component: ManageChecklistTemplate,
      meta: {
        module: 'checklist',
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresSupervisor: true,
        requiresOperator: true,
        requiresCoordOp: true,
        requiresCoordSector: false,
        requiresLaboratory: true,
      },
    },
    {
      name: 'editTemplate',
      path: '/editTemplate/:templateId',
      component: ManageChecklistTemplate,
      props: true,
      meta: {
        module: 'checklist',
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresSupervisor: true,
        requiresOperator: true,
        requiresCoordOp: false,
        requiresCoordSector: false,
        requiresLaboratory: true,
      },
    },
    {
      name: 'formChecklist',
      path: '/formChecklist',
      component: ManageChecklistServiceOrder,
      meta: {
        module: 'checklist',
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresSupervisor: true,
        requiresOperator: true,
        requiresCoordOp: false,
        requiresCoordSector: false,
        requiresLaboratory: true,
      },
    },
  ],
}

export default ChecklistsRoutes
